<template lang="pug">
  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle.d-none(:id="tblId")
    thead.thead-light
      tr
        th.text-center(width="3%")
          span #
        th(width="5%")
          span(:title="$t('ui.id')") {{ $t('ui.id') }}
        th(width="5%")
          span(:title="$t('ui.ref_no')") {{ $t('ui.ref_no') }}
        th(width="8%")
          span(:title="$t('ui.operator_id')") {{ $t('ui.operator_id') }}
        th(width="8%")
          span(:title="$t('ui.member')") {{ $t('ui.member') }}
        th.text-right(width="7%")
          span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
        th.text-right(width="10%")
          span(:title="$t('ui.approve_time')") {{ $t("ui.approve_time") }}
        th.text-right(width="10%")
          span(:title="$t('ui.audit_time_created')") {{ $t("ui.audit_time_created") }}
    tbody.clusterize-content
      tr(v-if="tbl.length == 0")
        td(colspan="14").text-center
          span {{ $t('message.no_data_available') }}
      tr(v-for="(item, index) in tbl" :class="$helpers.rowClassTicket(item, 'withdrawal')")
        td.text-center
          span(:title="index + 1") {{ index + 1 }}
        td
          span.d-block(:title="item.id") {{ item.id }}&nbsp;
        td
          span.small.text-info.d-block(:title="getRefNo(item.sender_bank_id, item.id, item.prefix_fc, item.prefix_delimiter)") {{ getRefNo(item.sender_bank_id, item.id, item.prefix_fc, item.prefix_delimiter) }}&nbsp;
        td
          span(:title="item.operator_id") {{ item.operator_id }}&nbsp;
        td
          span.font-weight-bold(:title="item.account_id") {{ item.account_id }}
        td.text-right
          span.font-weight-bold.d-block(:title="$n(item.amount, 'currency')" :class="$helpers.fontClassName(item.amount)") {{ $n(item.amount, 'currency') }}
        td.text-right
          span(v-if="item.modified_date" :title="$moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss') }}
        td.text-right
          span(v-if="item.created_date" :title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
      tr.footer
        td.text-right(colspan="5")
          span {{ $t("ui.sub_total") }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalAmount)" :title="$n(subTotalAmount, 'currency')") {{ $n(subTotalAmount, 'currency') }}
      tr.footer
        td.text-right(colspan="5")
          span {{ $t("ui.grand_total") }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalAmount)" :title="$n(grandTotalAmount, 'currency')") {{ $n(grandTotalAmount, 'currency') }}
</template>
<script>
export default {
  props: {
    tbl: {
      type: Array,
      default() {
        return []
      }
    },
    tblId: {
      type: String,
      default: ""
    },
    ticketStatus: {
      type: String,
      default: ""
    },
    totalTbl: {
      type: Number
    },
  },
  data: () => ({
    loading: false,
    subTotalAmount: 0,
    grandTotalAmount: 0,
  }),
  watch: {
    tbl(newValue, oldValue) {
      this.getTotal();
    },
  },
  mounted: function() {
    this.getTotal();
  },
  methods: {
    getRefNo: function(bank_id, id, prefix, delimiter) {
      return this.$helpers.getPaymentGatewayRefNoSetMember(bank_id, id, prefix, delimiter);
    },
    clearTotal() {
      this.subTotalAmount = 0
      this.grandTotalAmount = 0
    },
    getTotal: function() {
      this.clearTotal();
      var tbl = this.tbl;
      if(tbl.length > 0) {
        tbl.forEach(value => {
          this.subTotalAmount = parseFloat(this.subTotalAmount) + parseFloat(value["amount"]);
        });

        var totalTbl = this.totalTbl;
        this.grandTotalAmount =totalTbl;
      }
    }
  }
};
</script>
